import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
  UnsegmentedResponse,
} from '../../../common/types';
import { getChartDataFromUnsegmentedResponse } from '../../../common/utils';
import {
  TimePeriodUnsegmentedVizData,
  TimePeriodUnsegmentedVizExternalProps,
} from '../../types';
import {
  TimePeriodUnsegmentedPieChartActions,
  TimePeriodUnsegmentedPieChartState,
  TimePeriodUnsegmentedPieChartUiComponentProps,
} from './types';

export const timePeriodUnsegmentedPieChartDataToUiComponentProps = (
  data: TimePeriodUnsegmentedVizData,
  externalProps: TimePeriodUnsegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    TimePeriodUnsegmentedPieChartState,
    TimePeriodUnsegmentedPieChartActions
  >,
  { dataFieldValueFormatter }: DataVizContainerCommonUtils
): TimePeriodUnsegmentedPieChartUiComponentProps => {
  const { fullScreenHandle, preferences } = externalProps;
  const { dataResponse, titleConfig, metricDetails, metricDisplayValues } =
    data;
  // @alex - similar to the comment in TimePeriodUnsegmentedViz
  if (dataResponse.responseForMetrics.length > 1) {
    throw new Error('Pie chart currently only supports single dataset');
  }
  const { metric, metricSql, groups } = dataResponse.responseForMetrics[0];
  const singleMetricUnsegmentedResponse: UnsegmentedResponse = {
    isSegmented: false,
    groupBy: dataResponse.groupBy,
    metric,
    metricSql,
    groups,
  };
  const chartData = getChartDataFromUnsegmentedResponse(
    singleMetricUnsegmentedResponse,
    preferences,
    metricDetails,
    metricDisplayValues,
    dataFieldValueFormatter
  );
  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };
  return {
    fullScreenHandle,
    displayConfig,
    titleConfig,
    chartData,
    chartColors: data.chartColors,
    pieBenchmarkSubRows: data.pieBenchmarkSubRows,
    pieFooter: data.pieFooter,
  };
};
